import { LabCardData } from "@hub/models/document/document-card-data";
import { HeadMetadata } from "@hub/models/metadata/head-metadata";
import { BannerConfig } from "@hub/models/ui/banner-config";
import { Breadcrumb } from "@hub/models/ui/breadcrumb";
import { PageConfig } from "@hub/models/ui/page-config";
import {
  hubOriginUrl,
  hubSiteTree,
  SiteTreeSectionKeys,
} from "@hub/services/config.service";
import { getBreadCrumbs } from "@hub/services/content/common/get-breadcrumbs";
import { WorkshopData } from "@hub/services/content/models/workshops-data";
import { createUrlPath } from "@hub/services/utils/path.utils";
import { GetStaticProps } from "next";
import React from "react";
import { AllWorkshopsPage } from "../../components/all-workshops-page";

interface WorkshopsIndexProps {
  canonicalUrl: string;
  contentCardData: LabCardData[];
  breadcrumbs?: Breadcrumb[];
}

const WorkshopsIndex: React.FC<WorkshopsIndexProps> = ({
  canonicalUrl,
  contentCardData,
  breadcrumbs,
}) => {
  const headMetadata: HeadMetadata = {
    title: "Auth0 Developer Workshops",
    description:
      "Learn how to implement authentication and authorization following engaging and interactive workshops.",
    url: canonicalUrl,
    image:
      "https://cdn.auth0.com/website/developer-center/preview-cards/resources_workshops.png",
    type: "website",
  };

  const pageConfig: PageConfig = {
    canonicalUrl,
    title: "Auth0 Authentication and Authorization Developer Workshops",
    description:
      "Learn how to implement authentication and authorization following engaging and interactive workshops.",
  };

  const bannerConfig: BannerConfig = {
    title: "Developer Workshops",
    description:
      "Engaging and interactive sessions to learn about the security features of Auth0.",
    withBorder: true,
  };

  return (
    <AllWorkshopsPage
      contentCardData={contentCardData}
      bannerConfig={bannerConfig}
      pageConfig={pageConfig}
      breadcrumbs={breadcrumbs}
      headMetadata={headMetadata}
    />
  );
};

export default WorkshopsIndex;

export const getStaticProps: GetStaticProps<WorkshopsIndexProps> = async () => {
  const workshopData = new WorkshopData();

  const breadcrumbs = getBreadCrumbs({
    root: {
      label: hubSiteTree.root.displayName,
      path: hubSiteTree.root.urlPath,
    },
    sections: [
      {
        label: hubSiteTree.root.sections.workshops.displayName,
        path: hubSiteTree.root.sections.workshops.urlPath,
      },
    ],
  });

  const canonicalUrl =
    hubOriginUrl +
    createUrlPath([
      hubSiteTree.root.urlPath,
      hubSiteTree.root.sections[SiteTreeSectionKeys.WORKSHOPS].urlPath,
    ]);

  const props: WorkshopsIndexProps = {
    canonicalUrl,
    contentCardData: workshopData.cards.workshops,
    breadcrumbs,
  };

  return {
    props,
  };
};
